import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const clearState = createAction(Constants.TRANSACTION_UPLOAD_FILE_CLEAR_STATE,  () => ({}));

export const uploadFileCSVSuccess = createAction(Constants.RESOLVE_UPLOAD_FILE.SUCCESS, (info) => (info));
export const uploadFileCSVRequest = createAction(Constants.RESOLVE_UPLOAD_FILE.REQUEST, (info) => (info));
export const uploadFileCSVFailed = createAction(Constants.RESOLVE_UPLOAD_FILE.FAILED, (info) => (info));
